import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { FirebaseAuthService } from '../../../shared/firebase-auth.service';

/** Error page shown when the application encounters an unrecoverable server-side error. */
@Component({
  selector: 'app-server-error',
  imports: [MatCardModule, MatButtonModule, MatIconModule, MatExpansionModule],
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss'],
})
export class ServerErrorComponent implements OnInit, AfterViewInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private authService = inject(FirebaseAuthService);

  errorMessage: string | null = null;

  @ViewChild('statusHeading') private statusHeading?: ElementRef<HTMLElement>;

  ngOnInit(): void {
    this.errorMessage = this.route.snapshot.queryParamMap.get('message');
  }

  ngAfterViewInit(): void {
    queueMicrotask(() => this.statusHeading?.nativeElement.focus());
  }

  /**
   * Switch to a different Google account
   * Issue #304: Force account selection without signing out to prevent UI leaks
   */
  switchAccount(): void {
    // Force Google account chooser without signing out first
    // This prevents the UI leak that occurs during sign-out -> sign-in transition
    this.authService.signIn(true);
  }

  /**
   * Sign out completely (for untrusted computers)
   */
  signOut(): void {
    this.authService.signOut();
  }

  retry(): void {
    // Reload the current page to retry the authentication flow
    window.location.reload();
  }
}
